import { claddingIds } from '../../shared/values/cladding-ids';

export const claddings = {
  'Brick Guards': claddingIds.brickguards,
  'Debris Netting': claddingIds.netting,
  'Sheeting': claddingIds.sheeting
};
